    const removeItem = function (key) {
        localStorage.removeItem(key);
    }

    const setExpiredItem = function (key, value) {
        var item = {
            'value': value,
            'expiration': new Date()
        };

        localStorage.setItem(key, JSON.stringify(item));
    }

    const setItem = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    const getItem = function (key) {
        return JSON.parse(localStorage.getItem(key));
    }

    const renew = function (key) {
        var item = getItem(key);
        if (item.expiration) {
            item.expiration = new Date();

            localStorage.setItem(key, JSON.stringify(item));
        }
    }

    const checkExpiration = function (key, expiration) {
        var item = getItem(key);
        if (item.expiration) {
            var itemexpiration = new Date(item.expiration);

            var lifetime = expiration || Config.StorageExpiration;

            if ((new Date() - itemexpiration) < lifetime) {
                return item;
            } else {
                return null;
            }
        }
        return null;
    }

    const checkIfExists = function (key) {
        return (localStorage.getItem(key) !== null);
    }


export default {
    getItem,
    setItem
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/localStorage.js